import { QueryStringObject } from '../../core/typings/api';

/**
 * Calendar filters query string key map.
 */
export const queryStringParamsKeyMap: string[] = [
  'discipline',
  'raceCategory',
  'raceType',
  'raceClass',
  'country',
  'year',
  'seasonId',
];

/**
 * Extracts all relivent querystring params
 * @returns
 */
export const mapQueryStringParams = (disciplineCode: string) => {
  const mappedQueryParams: QueryStringObject = {};
  const urlQueryParms = Object.fromEntries(
    new URLSearchParams(location.search),
  );

  Object.entries(urlQueryParms).forEach(
    ([key, value]) => {
      if (queryStringParamsKeyMap.includes(key)) {
        mappedQueryParams[key] = value;
      }
    },
  );
  return {
    discipline: disciplineCode,
    ...mappedQueryParams,
  };
};

/**
 * Resets the querystring by removing all related
 * qyery key listed in quertStringParamsKeyMap.
 */
export const resetQueryString = () => {
  const searchParams = new URLSearchParams(location.search);
  const urlQueryParms = Object.fromEntries(
    searchParams,
  );
  Object.entries(urlQueryParms).forEach(
    ([key]) => {
      if (queryStringParamsKeyMap.includes(key)) {
        searchParams.delete(key);
      }
    },
  );
  history.pushState(
    null,
    '',
    `${window.location.pathname}?${searchParams.toString()}`,
  );
};

/**
 * Generate querystring based on passed object. This
 * updates querystring entries and removes them if
 * passed in as undefined or as an empty string.
 * @param params
 */
export const generateQueryString = (params: QueryStringObject) => {
  const searchParams = new URLSearchParams(window.location.search);

  Object.keys(params).map((param) => {
    if (params[param] !== undefined && params[param] !== '') {
      return searchParams.set(param, params[param]);
    }
    return searchParams.delete(param);
  });

  history.pushState(
    null,
    '',
    `${window.location.pathname}?${searchParams.toString()}`,
  );
};
